import { Inbox } from 'lucide-react';
import { cn } from '../lib/utils.js';

/**
 * Explains why nothing is shown (docs/frontend/portal.md §3) and optionally offers an action.
 * @param {{
 *   icon?: import('react').ComponentType<{ className?: string, 'aria-hidden'?: boolean|'true' }>,
 *   title: import('react').ReactNode,
 *   description?: import('react').ReactNode,
 *   action?: import('react').ReactNode,
 *   className?: string,
 *   compact?: boolean,
 * }} props
 */
export function EmptyState({ icon: Icon = Inbox, title, description, action, className, compact = false }) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed text-center',
        compact ? 'px-4 py-6' : 'px-6 py-12',
        className,
      )}
    >
      <div className="flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Icon className="size-5" aria-hidden="true" />
      </div>
      <p className="text-sm font-semibold">{title}</p>
      {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
